var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoiceFooterEditBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.71429 0.442993C0.774498 0.442993 0 1.35856 0 2.46951V17.3307C0 18.4416 0.774498 19.3572 1.71429 19.3572H14.2857C15.2255 19.3572 16 18.4416 16 17.3307V9.88272C16 9.70359 15.9398 9.53185 15.8327 9.40504C15.7255 9.27838 15.5801 9.20721 15.4286 9.20721C15.277 9.20721 15.1316 9.27838 15.0245 9.40504C14.9173 9.53185 14.8571 9.70359 14.8571 9.88272V17.3307C14.8571 17.7165 14.6121 18.0062 14.2857 18.0062H1.71429C1.38788 18.0062 1.14286 17.7165 1.14286 17.3307V2.46951C1.14286 2.08366 1.38788 1.79401 1.71429 1.79401H8C8.15153 1.79401 8.29694 1.72284 8.40408 1.59618C8.51122 1.46952 8.57143 1.29763 8.57143 1.1185C8.57143 0.939371 8.51122 0.767476 8.40408 0.64082C8.29694 0.514165 8.15153 0.442993 8 0.442993H1.71429Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86443 9.43987C4.77642 9.54406 4.71966 9.67931 4.7027 9.82512L4.25996 13.5838C4.20766 14.0297 4.53189 14.4101 4.90867 14.3451L8.06773 13.7975C8.18941 13.7762 8.30204 13.7091 8.3889 13.6063L15.6532 5.01887C16.1102 4.47862 16.1102 3.58313 15.6532 3.04287L13.801 0.853345C13.3442 0.313249 12.5857 0.312168 12.1287 0.85244L4.86443 9.43987ZM5.80755 10.2357C8.1763 7.4352 10.6389 4.52477 12.9635 1.77603L14.8715 4.02632C12.5238 6.8152 10.0931 9.68127 7.71397 12.4933L5.49712 12.8786L5.80755 10.2357Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceFooterEditBtn);
export default __webpack_public_path__ + "static/media/invoice-footer-edit-btn.e381958490d1112c5d3be0ee9319daa5.svg";
export { ForwardRef as ReactComponent };